<div class="container" #form>
    <div class="row header">
        <div mat-dialog-title class="col-md-10">
            {{popupTitle | translate}}
        </div>
        <div class="col-md-2 icon" (click)="close()">
            <asp-icon name="ic-20-utility-close-default.svg"></asp-icon>
        </div>
    </div>
</div>
<form  [formGroup]="holidayForm">
    <div class="container-fluid">
        <div class="row" style="padding-top: 1rem;">
            <div class="col-md-12">
                <div>{{ 'departmentHolidays.name' | translate }}</div>
                <mat-form-field appearance="outline">
                    <input matInput placeholder="{{ 'departmentHolidays.holidayName' | translate }}" formControlName='holidayName'> 
                    <mat-error [innerHTML]=" 'departmentHolidays.nameIsRequired' | translate">
                    </mat-error>
                      
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div>{{ 'appointmentPrint.date' | translate | titlecase}}</div>
                <mat-form-field appearance="outline">
                    <input matInput [matDatepicker]="picker" placeholder="{{ 'departmentHolidays.chooseDate' | translate }}" formControlName='holidayDate'>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="holidayForm.controls.holidayDate.hasError('required')" [innerHTML]="'departmentHolidays.dateIsRequiredStrong' | translate ">
                    </mat-error>
                  </mat-form-field>
            </div>
        </div>
        <div class="row col-md-12 duration" >
            <div class="col-md-12" style="margin-left: 0.5rem;">
                <div class="row"><label>{{ 'departmentHolidays.duration' | translate }}</label></div> 
                <div class="row day-type-radio-group" >
                <mat-radio-group aria-label="Select an option" color="primary" formControlName="dayType" >
                  <mat-radio-button  value="1" [value]="'FULL'">{{ 'common.fullDay' | translate }}</mat-radio-button>
                  <mat-radio-button  value="2" [value]="'HALF'">{{ 'common.halfDay' | translate }}</mat-radio-button>
                </mat-radio-group>
                <mat-button-toggle-group *ngIf="holidayForm.value.dayType === 'HALF'"  name="fontStyle" aria-label="Font Style" value="AM" formControlName="dayTime">
                    <mat-button-toggle value="AM">
                        <span>AM</span>
                    </mat-button-toggle>
                    <mat-button-toggle value="PM">
                        <span>PM</span>
                    </mat-button-toggle>
                    </mat-button-toggle-group>
              </div>

              </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-checkbox formControlName='isRecurring'><div style="padding-top: 3px;">{{ 'departmentHolidays.recurringYearly' | translate }}</div></mat-checkbox>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="action-con">
                    <div class="add-new width-97" (click)="save()">
                        <button  class="add-holiday-btn">
                            <span>{{popupSaveTitle | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="action-con">
                    <div class="holiday-cancel width-97" (click)="close()">
                        <button  class="cancel-btn">
                            <span>{{ 'overrideCapacity.cancel' | translate }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</form>